
const he = require('he');

const mirrorURL = "http://mirror.3dwayfinder.com/";

const urls = {
    shops: {
        et: 'https://ulemiste.ee/wp-json/wf_wayfinder/v1/shops',
        en: 'https://ulemiste.ee/en/wp-json/wf_wayfinder/v1/shops',
        ru: 'https://ulemiste.ee/ru/wp-json/wf_wayfinder/v1/shops'
    },
    categories: {
        et: 'https://ulemiste.ee/wp-json/wp/v2/shop_category?per_page=100',
        en: 'https://ulemiste.ee/wp-json/wp/v2/shop_category?per_page=100',
        ru: 'https://ulemiste.ee/wp-json/wp/v2/shop_category?per_page=100'
    },
    catering: {
        et: 'https://ulemiste.ee/wp-json/wf_wayfinder/v1/catering',
        en: 'https://ulemiste.ee/en/wp-json/wf_wayfinder/v1/catering',
        ru: 'https://ulemiste.ee/ru/wp-json/wf_wayfinder/v1/catering'
    },
    options: {
        et: 'https://ulemiste.ee/wp-json/acf/v3/options/options/',
        en: 'https://ulemiste.ee/en/wp-json/acf/v3/options/options/',
        ru: 'https://ulemiste.ee/ru/wp-json/acf/v3/options/options/'
    }
};

const imageURL = 'https://ulemiste.ee/wp-json/wp/v2/media/{id}?context=embed';

let perGroup = {};
let perExtShopId = {};
let wayfinder;
const useMirror = false;

function getURL(service, language, _extend) {
    let url = "";
    let extend = _extend ? _extend : "";
    if (useMirror) {
        url = mirrorURL;
    }

    url += urls[service][language] + extend;
    return url;
}
 
function loadShops () {
    return new Promise((resolve) => {
        Promise.all(Object.entries(urls["shops"]).map(async (url) => {
            const preFetchData = await fetch(url[1]);
            const data = await preFetchData.json();
            return [url[0], data];
        })).then(_data => {
            resolve(new Map(_data));
        })        
    });
}

function loadCatering () {
    return new Promise((resolve) => {
        Promise.all(Object.entries(urls["catering"]).map(async (url) => {
            const preFetchData = await fetch(url[1]);
            const data = await preFetchData.json();
            return [url[0], data];
        })).then(_data => {
            resolve(new Map(_data));
        })        
    });
}
/*function decodeHTMLEntities (str) {
    if (str && typeof str === 'string') {
        str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
        str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
    }

    return str;
}*/

function transformGroup(group) {
    console.log('transformGroup', group)
    return {
        'et': group.name.replace(/&amp;/g, '&'),
        'en': group?.acf?.shop_category_title_eng?.replace(/&amp;/g, '&'),
        'ru': group?.acf?.shop_category_title_rus?.replace(/&amp;/g, '&'),
        'group_id': group.id,
        'color': '#ff00ff',
        'parent_id': 0,
        'show_top': false,
        'show_main': true
    }
}
function addToGroup (poiGroup, poi) {
    for(let p in poiGroup.pois) {
        
        if (poiGroup.pois[p] && poiGroup.pois[p].id == poi.id) {
            console.log('not to group', poi.id, poi.getName("et"))
            return;
        }
    }
    poiGroup.pois.push(poi);
}

function addGroup (poi, poiGroup) {
    for(let g in poi.groups) {
        
        if (poi.groups[g] && poi.groups[g].id == poiGroup.id) {
            return;
        }
    }
    poi.addGroup(poiGroup);
}
function loadCategories (language) {
    return new Promise((resolve, reject) => {
        fetch(getURL("categories", language)).then(resp1 => resp1.json()).then(categories => {
            let cat, poiGroup;
            for (let i = 0; i < categories.length; i++) {
                cat = categories[i];
                
                poiGroup = wayfinder.factory.createPOIGroup(transformGroup(cat), wayfinder.getLanguages());
                poiGroup['slug'] = cat.slug;
                poiGroup['cat_id'] = cat.id;
                poiGroup['notify'] = true;
                poiGroup['parent_id'] = null;

                if (typeof perGroup[cat.id] === 'object') {
                    for (let ii = 0; ii < perGroup[cat.id].length; ii++) {
                        addToGroup(poiGroup, perGroup[cat.id][ii]);
                        addGroup(perGroup[cat.id][ii], poiGroup)
                    }
                }
                wayfinder.poiGroups[cat.id] = poiGroup;
            }

            resolve();
        }).catch(err => {
            reject(err);
        });
    })
}

function findByRoomId () {
    var poi;
    var perRoomId = {};
    for (var p = 0; p < wayfinder.poisArray.length; p++) {
        poi = wayfinder.poisArray[p]
        perRoomId[poi.room_id] = poi
    }

    return perRoomId
}

async function makeShops (shops, language) {
    this.perRoomId = findByRoomId();
    /*shops.map((p) => {
        console.log(p.title, p.acf.shop_id)
    });*/
    var cat, poi, shop, room;
    var pois404 = [];

    for (var j = 0; j < shops.length; j++) {
        shop = shops[j];
        if (shop.acf && shop.acf.shop_id !== '') {
            room = wayfinder.getRoom(shop.acf.shop_id);
            if (room && room.pois.length > 0) {
                poi = room.pois[0];
                poi.names.set('et', he.decode(shop.title));
                poi.names.set('en', he.decode(shop.title));
                poi.names.set('ru', he.decode(shop.title));
                poi.shopHasName = true;
                poi.descriptions.set(language, shop.acf.shop_text);
                poi.url = shop.acf.shop_www !== '' ? shop.acf.shop_www : false;
                poi.phone = shop.acf.shop_phone !== '' ? shop.acf.shop_phone : false;
                poi.email = shop.acf.shop_email !== '' ? shop.acf.shop_email : false;
                poi.opening_hours = shop.acf.shop_time !== '' ? shop.acf.shop_time : false;
                poi.shop_facebook = shop.acf.shop_facebook !== '' ? shop.acf.shop_facebook : false;
                poi.shop_logo = shop.acf.shop_logo;
                poi.shop_photo = shop.acf.shop_photo;
                poi.shop_id = shop.acf.shop_id;
                poi.showInMenu = true;
                // console.log(poi.id, "room_id", poi.room_id, "shop-id",shop.acf.shop_id, shop.title.rendered)

                perExtShopId[shop.id] = poi;

                if (shop.shop_category) {
                    for (var c = 0; c < shop.shop_category.length; c++) {
                        cat = shop.shop_category[c];
                        if (!perGroup[cat]) {
                            perGroup[cat] = []
                        }
                        perGroup[cat].push(poi);
                    }
                }
            }
            else {
                pois404.push([shop.title.rendered, shop.acf.shop_id])
            }
        }
    }

    console.table(pois404);
}

function translateShops (shops, lang) {
    let shop, poi;
    for (let j = 0; j < shops.length; j++) {
        shop = shops[j];
        if (shop.acf && shop.acf.shop_id !== '') {
            poi = this.perRoomId[shop.acf.shop_id];
            if (poi) {
                poi.names.set(lang, he.decode(shop.title));
                poi.descriptions.set(lang, shop.acf.shop_text);
            }
        }
    }
}

function getOptions () {
    return new Promise((resolve, reject) => {
        fetch(getURL("options", "et")).then(resp1 => resp1.json()).then((options) => {
            if (options && options['acf']) {
                options = options['acf'];
                let openingHours = options['opening_hours_1'] !== '' ? '<label><b>' + options['opening_hours_1'].replace(' ', '</b> ') + '</label>' : '';
                openingHours += options['opening_hours_2'] !== '' ? ' <label><b>' + options['opening_hours_2'].replace(' ', '</b> ') + '</label>' : '';
                openingHours += options['opening_hours_3'] !== '' ? ' <label><b>' + options['opening_hours_3'].replace(' ', '</b> ') + '</label>' : '';

                if (options['show_crowd_checker_public']) {
                    var _s;
                    for (var s in options['centre_status_content']) {
                        _s = options['centre_status_content'][s];
                        if (_s['acf_fc_layout'] === options['centre_status']) {
                            break;
                        }
                    }
                }

                let opt = {
                    openingHours: openingHours
                }
                resolve(opt);
            }
        }).catch(err => {
            reject(err);
        });
    });
}

async function getImageUrl (id) {
    return new Promise(function (resolve, reject) {
        if (!id) return reject(new Error('No ID given'));

        fetch(imageURL.replace('{id}', id)).then(resp1 => resp1.json()).then(photo => {
            if (photo) {
                if (photo.media_details.sizes.medium) {
                    resolve(photo.media_details.sizes.medium.source_url);
                }
                else {
                    resolve(photo.source_url);
                }
            }
            else {
                reject(new Error('No body'))
            }
        });
    })
}

async function makeData () {
    return new Promise((resolve, reject) => {
        loadShops('et').then(_shops => {
            loadCatering().then(_catering => {
                makeShops(_shops.get('et').concat(_catering.get('et')), 'et').then(() => {
                    translateShops(_shops.get('en').concat(_catering.get('en')), 'en');
                    translateShops(_shops.get('ru').concat(_catering.get('ru')), 'ru');
                    loadCategories('et').then(() => {
                        resolve();
                    });
                }).catch(e => {
                    reject(e);
                })
            });
        }).catch(e => {
            reject(e);
        })
    });
}

async function getShops (_wayfinder) { 
    wayfinder = _wayfinder;
    return makeData();  
}

module.exports = {
    getShops: getShops,
    getOptions: getOptions,
    getImageUrl: getImageUrl
}